import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { LoadingDotsIcon } from "mds/icons";
import { Link } from "utils/routing";

type LoadingScreenProps = {
  children?: ReactNode;
};

export const LoadingScreen: FC<LoadingScreenProps> = ({ children = t("common.loading") }) => (
  <div className="h-full w-full">
    <div className="animate-fade-in flex h-full w-full flex-col items-center justify-center gap-3">
      {children}
    </div>
  </div>
);

type LoadingTextIndicatorProps = {
  children: ReactNode;
  className?: string;
  height?: number;
};

export const LoadingTextIndicator: FC<LoadingTextIndicatorProps> = ({
  children,
  className,
  height,
}) => (
  <div className={twMerge("mt-4", className)}>
    <div
      className="animate-fade-in flex flex-col items-center justify-center gap-2"
      style={height ? { height } : {}}
    >
      <div>{children}</div>
      <LoadingDotsIcon />
    </div>
  </div>
);

type ErrorScreenProps = {
  children?: ReactNode;
  className?: string;
  retryText?: string;
  onRetry?: () => void;
};

export const ErrorScreen: FC<ErrorScreenProps> = ({
  children = t("error.generic_message"),
  className,
  retryText = t("error.return_home"),
  onRetry,
}) => {
  return (
    <div className={twMerge("flex w-full flex-col items-center justify-center gap-2", className)}>
      <div className="h2">{children}</div>
      {onRetry ? (
        <SquareButton kind="tertiary" size="m" onClick={onRetry}>
          {retryText}
        </SquareButton>
      ) : (
        <Link to="/">{t("error.return_home")}</Link>
      )}
    </div>
  );
};
